module.exports = __webpack_public_path__ + "static/droplets-01-3f51b93fbe1212fbb94f323187759537.png";